import React, { useState, useEffect, useContext, useRef } from "react";
import { useTranslation } from "react-i18next";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Toast } from "primereact/toast";
import { InputTextarea } from "primereact/inputtextarea";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { InputNumber } from "primereact/inputnumber";
import { AuthContext } from "../../Header/auth - context";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Column } from "primereact/column";
import { Tooltip } from 'primereact/tooltip';
import { FileUpload } from 'primereact/fileupload';
import CustomDropdown from "../../custom/customDropdown";
import usePermission from "../../custom/usePermission";
import "primeicons/primeicons.css";
import './PlanerTura.css';
import { Accordion, AccordionTab } from 'primereact/accordion';
import ConfirmationModalPlanner from "../../custom/ConfirmationModalPlanner";
import { MultiSelect } from "primereact/multiselect";
import { useLocation } from "react-router-dom";
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

const PregledPlanaTure = (props) => {
  const { t } = useTranslation();
  const { can } = usePermission();

  const auth = useContext(AuthContext);
  const toast = useRef(null);
  const formRef = useRef(null);
  const company = useSelector((state) => state.company);
  const user = useSelector((state) => state.user);
  const eskaliran = useSelector((state) => state.eskaliran);
  const userRole = useSelector((state) => state.user_role);

  const [formSubmitted, setFormSubmitted] = useState(false);
  const [confirmVisible, setConfirmVisible] = useState(false); 

  const [statusPlanerDB, setStatusPlanerDB] = useState([]);
  const [klijentiDB, setKlijentiDB] = useState([]);
  const [vozilaDB, setVozilaDB] = useState([]);
  const [prikljucnaDB, setPrikljucnaDB] = useState([]);
  const [vozaciDB, setVozaciDB] = useState([]);
  const [rezimDB, setRezimDB] = useState([]);
  const [tipPrevozeDB, setTipPrevozeDB] = useState([]);
  
  const [idItem, setIdItem] = useState(null);

    const [columns, setColumnsDB] = useState([]);
    const [isLoadedConfig, setIsLoadedConfig] = useState(false);
    const [originalColumnOrder, setOriginalColumnOrder] = useState([]);
  //Stavke
  const [izabran, setIzabran] = useState(false);

  const [allColumns, setAllColumns] = useState([]);
  const isSelected = (row) => String(getId(row)) === String(selectedRowId);
  const [selectedRowId , setSelectedRowId] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [first, setFirst] = useState(0);
  /* Mora uz "first": onPage cini stranicanje kontrolisanim, pa DataTable i broj
     redova cita iz propsa. Dok je ovde stajala fiksna vrednost, izbor u
     paginatoru se vracao na staro pri svakom iscrtavanju. */
  const [rows, setRows] = useState(25);
  const getId = (row) => row?.ID ?? row?.id ?? row?.Izaberi ?? null; 
  
  const Add2HoursDate = (input) => {
    const base = new Date(input);
    const plus2h = new Date(base.getTime() + 2 * 60 * 60 * 1000);

    return plus2h
  }

  const returnCourseForDate = (valutaOp,nalogValuta, kurseviOp,date) => {

          const base = new Date(date);
          const plus2h = new Date(base.getTime() + 2 * 60 * 60 * 1000);

          const toLocalYMD = (d) =>
            `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

          const valutaId = Number(nalogValuta);

          let d = new Date(plus2h);
          let kurs = null;

          for (let i = 0; i < 365; i++) {
            const day = toLocalYMD(d);

            // IMPORTANT: DateEntered je string -> uporedi slice(0,10), ne new Date(...).toISOString()
            kurs = kurseviOp.find(x =>
              Number(x.id) === valutaId &&
              typeof x.DateEntered === "string" &&
              x.DateEntered.slice(0, 10) === day
            );

            if (kurs) break;

            // idi 1 dan unazad
            d.setDate(d.getDate() - 1);
          }
          return kurs ? kurs.srednji : null

  }

  const returnCourseForToday = (valutaOp,nalogValuta, kurseviOp) => {
       const base = new Date();
          const plus2h = new Date(base.getTime() + 2 * 60 * 60 * 1000);

          // helper: lokalni YYYY-MM-DD (bez UTC zezanja)
          const toLocalYMD = (d) =>
            `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

          const valutaFinal = valutaOp.find(x => x.value == nalogValuta);
          if (!valutaFinal) {
            console.log("Nema valute za:", nalogValuta);
            return;
          }

          const valutaId = Number(valutaFinal.value); // da se poklope tipovi sa x.id

          // traži unazad do 365 dana (promeni po želji)
          let d = new Date(plus2h);
          let kurs = null;

          for (let i = 0; i < 365; i++) {
            const day = toLocalYMD(d);

            // IMPORTANT: DateEntered je string -> uporedi slice(0,10), ne new Date(...).toISOString()
            kurs = kurseviOp.find(x =>
              Number(x.id) === valutaId &&
              typeof x.DateEntered === "string" &&
              x.DateEntered.slice(0, 10) === day
            );

            if (kurs) break;

            // idi 1 dan unazad
            d.setDate(d.getDate() - 1);
          }
          return kurs.srednji

  }

  useEffect(() => {
    return () => {
      setIzabran(false)
      resetData();
    };
  }, []);
    
  // ====== DATA =====

  const [formData, setFormData] = useState({
    datum_utovara: null,
    vreme_utovara: null,
    tip_prevoza: null,
    id_klijent: null,
    mesto_utovara: '',
    mesto_istovara: '',
    id_vozilo: null,
    id_prikljucno: null,
    id_vozac: null,
    tezina: null,
    broj_paleta: '',
    rezim: null,
    napomena: '',
    /* Dopuna uz obavezan „Tekst" — cuva se u koloni `detalji`. */
    detalji: '',
    status_plana: null,
    datum_ugovaranja: null
  });

      
  /* Vreme se u bazi čuva kao TIME; ovde se prevodi u Date (za Calendar) i nazad. */
  const vremeUDate = (v) => {
      if (!v) return null;
      if (v instanceof Date) return v;
      const m = /^(\d{2}):(\d{2})/.exec(String(v));
      if (!m) { const d = new Date(v); return isNaN(d.getTime()) ? null : d; }
      const d = new Date();
      d.setHours(Number(m[1]), Number(m[2]), 0, 0);
      return d;
  };

  const vremeUString = (v) => {
      if (!v) return null;
      const d = v instanceof Date ? v : vremeUDate(v);
      if (!d) return null;
      return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}:00`;
  };

  function toUtcIso(d) {
    if (!d) return null;
    const x = d instanceof Date ? d : new Date(d);
    const utc = new Date(x.getTime() - x.getTimezoneOffset() * 60000);
    return utc.toISOString().slice(0, 19) + 'Z';
    }
  
  const handleErrors = (response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw response;
    }
  };

  const invalidControl = (data) => {
    if (!formSubmitted) return false;

    if (data && data != null && !Number(data)) {
      return data.length > 0 ? false : true;
    } else if (data != null && Number(data)) {
      return false;
    }
    return true;
  };

  const addDays = (date, days) => {
    if (!date || days === null || days === undefined) return null;
    const d = date instanceof Date ? new Date(date) : new Date(date);
    if (isNaN(d.getTime())) return null;
    const n = Number(days);
    if (Number.isNaN(n)) return null;
    d.setDate(d.getDate() + n);
    return d;
  };

  const resetData = () => {
    setFormData({
        datum_utovara: null,
        vreme_utovara: null,
    vreme_utovara: null,
        tip_prevoza: null,
        id_klijent: null,
        mesto_utovara: '',
        mesto_istovara: '',
        id_vozilo: null,
        id_prikljucno: null,
        id_vozac: null,
        tezina: null,
        broj_paleta: null,
        rezim: null,
        napomena: '',
        detalji: '',
        status_plana: null,
        datum_ugovaranja: null
  });
  }

  const handleChange = (e) => {
    const { name, value } = e.target || e;

  if (name in formData) {

        setFormData(prev => ({ ...prev, [name]: value}));
  }

  };

  const popuniStavke = (apiData) => {

    setFormData({
        datum_utovara: apiData.datum_utovara ? new Date(apiData.datum_utovara) : null,
        tip_prevoza: apiData.tip_prevoza || null,
        id_klijent: apiData.id_klijent || null,
        mesto_utovara: apiData.mesto_utovara || '',
        mesto_istovara: apiData.mesto_istovara || '',
        id_vozilo: apiData.id_vozilo || null,
        id_prikljucno: apiData.id_prikljucno || null,
        id_vozac: apiData.id_vozac || null,
        tezina: apiData.tezina || null,
        broj_paleta: apiData.broj_paleta || null,
        rezim: apiData.rezim || null,
        napomena: apiData.napomena || '',
        detalji: apiData.detalji || '',
        vreme_utovara: vremeUDate(apiData.vreme_utovara),
        status_plana: apiData.status_plana || null,
        datum_ugovaranja: apiData.datum_ugovaranja ? new Date(apiData.datum_ugovaranja) : null,
    });
}

  const popuniRedove = async (id) => {

             setIzabran(true)
              let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id: id,
                                step: 'GET'
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/trip/ManageTripPlanner", requestOptions)
                            .then(handleErrors)
                            .then((data) => {
                                
                                if(data.message){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data.message,
                                    life: 3000,
                                    });
                                    return
                                }  

                                popuniStavke(data[0])

                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
          
    }

  const openModalItems = () => {
    setConfirmVisible(true);
  }

   const handleSaveConfig = () => {
           confirmDialog({
                      message: "Jel ste sigurni da želite sačuvati konfiguraciju?",
                      acceptLabel: "Da",
                      rejectLabel: "Ne",
                      icon: "pi pi-info-circle",
                      acceptClassName: "p-button-danger",
                      accept: acceptInsertConfig,
                      reject: rejectInsertConfig,
                      });
    }
  
    const acceptInsertConfig  = () => {
      if(selectedColumns.length > 0) {
         let requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + auth.token,
        },
        body: JSON.stringify({
          id_config: 348,
          parametri: selectedColumns
        }),
      };
      
      fetch(process.env.REACT_APP_BACKEND_URL + "/config/changeConfig", requestOptions)
        .then(handleErrors)
        .then((data) => {
  
  
            if(data.message && data.message == 'Nema izmena u podacima konfiguracije pregleda.'){
                  toast.current.show({
                      severity: "warn",
                      summary: "Upozorenje!",
                      detail: data.message,
                      life: 3000,
                      });
                  return
                  }  
                  setColumnsDB({ empty: false, data: [{"parametri": selectedColumns}] })
              toast.current.show({
                  severity: "success",
                  summary: "Uspešna izmena konfiguracije pregleda za planer!",
                  life: 3000,
              });
  
        })
        .catch((error) => {
          error.json().then((errorMessage) => {
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: errorMessage.message,
              life: 3000,
            });
            console.log(errorMessage);
          });
        });
      } else {
          toast.current.show({
                      severity: "warn",
                      summary: "Upozorenje!",
                      detail: "Morate imati barem 1 izabranu stavku!",
                      life: 3000,
                      });
      }
       
    }
    const rejectInsertConfig = () => {
      console.log('Config insert rejected!')
    }


    const isButtonColumn = (field) => {
    return field.startsWith('Izaberi') || 
           field.includes('File') || 
           field.includes('fajl') || 
           field.includes('upload') ||
           field.endsWith('LK') || // Lična karta
           field.endsWith('VD') || // Vozačka dozvola
           field.endsWith('PASS') || // Pasoš
           field.endsWith('VIZA') || // Viza
           field.includes('Dokument'); // Generic document
  };


    const chooseItem = async (rowData) => {    
      const id = getId(rowData);
  
  
      setSelectedRowId((prev) => {
        const next = String(prev) === String(id) ? null : String(id);
  
      if (next) {
        setIzabran(true);
        openModalItems(true)
   
      } else {
        setIzabran(false);
        openModalItems(false)
        setIdItem(null)
      }
  
      return next;
    });
    if(id){
        popuniRedove(id)
        setIdItem(id)
    }

    }

    useEffect(()=> {
        if(!formSubmitted){ let requestOptions = {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + auth.token,
                },body: JSON.stringify({
                        step: 'GETTYPES'
                }),
              };
              
              fetch(process.env.REACT_APP_BACKEND_URL + "/trip/ManageTripPlanner", requestOptions)
                .then(handleErrors)
                .then(async(data) => {
                  
                                const stringifiedJson = data[0]["JsonOutput"];
                                const parsedData = JSON.parse(stringifiedJson);
  
                                    setTableData(parsedData.TableData)
                                    setKlijentiDB(parsedData.KlijentiDB)
                                    setPrikljucnaDB(parsedData.PrikljucnaDB)
                                    setVozilaDB(parsedData.VozilaDB)
                                    setRezimDB(parsedData.RezimDB)
                                    setStatusPlanerDB(parsedData.StatusPlanerDB)
                                    setTipPrevozeDB(parsedData.TipPrevozeDB)
                                    setVozaciDB(parsedData.VozaciDB)

                                if(data.message){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data.message,
                                    life: 3000,
                                    });
                                    return
                                }  

                        if (parsedData.TableData && parsedData.TableData.length > 0) {
                        const columns = Object.keys(parsedData.TableData[0])
                            .filter(key => !['ID'].includes(key))
                            .map(key => ({
                            label: key,
                            value: key
                            }));
                
                        
                        setAllColumns(columns);
                        const originalOrder = Object.keys(parsedData.TableData[0]);
                        setOriginalColumnOrder(originalOrder);
                        
                            const columnsDB = await getConfigColumns();

                            if (!columnsDB.empty && columnsDB.data.length > 0) {
                                let arr;

                                if(typeof columnsDB?.data?.[0]?.parametri === "string")
                                arr = JSON.parse(columnsDB.data[0].parametri);
                                else
                                arr = columnsDB.data[0].parametri;

                                setSelectedColumns(arr);
                            } else {
                                setSelectedColumns(columns.slice(0, 5).map(col => col.value));
                            }
                        }
                })
                .catch((error) => {
                  error.json().then((errorMessage) => {
                    toast.current.show({
                      severity: "error",
                      summary: "Error",
                      detail: errorMessage.message,
                      life: 3000,
                    });
                    console.log(errorMessage);
                  });
                });
            }
    },[formSubmitted])

      const getConfigColumns = async () => {
    if(isLoadedConfig) { 
      return columns
    } else {
      const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + auth.token,
    },
    body: JSON.stringify({
      id_config: 348
    }),
  };

    const data = await fetch(process.env.REACT_APP_BACKEND_URL + "/config/", requestOptions)
      .then(handleErrors); 

    if (data.message) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: data.message,
        life: 3000,
      });
      setColumnsDB({ empty: true, data: [] })
      return { empty: true, data: [] };
    }
     
    setIsLoadedConfig(true)
    
    if(data.length > 0) {
                    setColumnsDB({ empty: false, data: data })
                    return { empty: false, data: data };
                } else {
                    setColumnsDB({ empty: true, data: [] })
                    return { empty: true, data: [] };
                }


    }
  
};

     const previewBodyTemplate = (rowData, field) => {
      const filePathsString = rowData[field];
      if (!filePathsString) return '-';
  
      const selected = isSelected(rowData);
     
      return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
              <Button
                label='Izaberi'
                icon="pi pi-eye"
                className="p-button-text p-button-sm"
                onClick={(e) => chooseItem(rowData)}
                tooltip="Izaberi stavku za dalji rad"
                tooltipOptions={{ position: 'top' }}
              />
            
        </div>
      );
    };

  const saveItems = () => {

    confirmDialog({
      message: "Jel ste sigurni da želite sačuvati stavku planera?",
      acceptLabel: "Da",
      rejectLabel: "Ne",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-danger",
      accept: () => acceptSaveItems(),
    });
  };

  const acceptSaveItems = async () => {

    try {

            const payload = {
                        ...formData,
                        datum_utovara:    toUtcIso(formData.datum_utovara),
                        datum_ugovaranja: toUtcIso(formData.datum_ugovaranja),
                        vreme_utovara:    vremeUString(formData.vreme_utovara),
                        };

            if(idItem){
                          let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id: idItem,
                                step: 'UPDATE',
                                formData: payload,
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/trip/ManageTripPlanner", requestOptions)
                            .then(handleErrors)
                            .then((data) => {

                               if(data[0].message && data[0].message != 'Nema izmena u podacima planera.'){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data[0].message,
                                    life: 3000,
                                    });
                                    return
                                }  

                                if(data[0].message == 'Nema izmena u podacima planera.'){
                                toast.current.show({
                                severity: "warn",
                                summary: data[0].message,
                                life: 3000,
                                });
                                
                                } else {
                                toast.current.show({
                                severity: "success",
                                summary: "Uspešna izmena podataka stavke!",
                                life: 3000,
                                });
                                setIdItem(null)
                                setIzabran(false)
                                setConfirmVisible(false)
                                setSelectedRowId(null)
                                setFormSubmitted(false)
                                }  
                               
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
           
            } else {
                  let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                step: 'INSERT',
                                formData: payload
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/trip/ManageTripPlanner", requestOptions)
                            .then(handleErrors)
                            .then((data) => {

                                if(data.message){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data.message,
                                    life: 3000,
                                    });
                                    return
                                }  
                                setIdItem(null)
                                setIzabran(false)
                                setSelectedRowId(null)
                                setFormSubmitted(false)
                                setConfirmVisible(false)

                               toast.current.show({
                                severity: "success",
                                summary: "Uspešan unos podataka stavke planera!",
                                life: 3000,
                                });

                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
                          
            }
    } catch (err) {
      toast.current?.show({
        severity: "error",
        summary: "Greška",
        detail: "Neuspešno čuvanje stavke.",
        life: 3000,
      });
    }
  };

  const handleFormRemoveItems = () => {
    confirmDialog({
      message: "Jel ste sigurni da želite pasivizirati stavku planera?",
      acceptLabel: "Da",
      rejectLabel: "Ne",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-danger",
      accept: acceptRemoveItems,
    });
  }

  const acceptRemoveItems = async () => {

     if(idItem){
        setFormSubmitted(true)
                          let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id: idItem,
                                step:'DELETE'
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/trip/ManageTripPlanner", requestOptions)
                            .then(handleErrors)
                            .then((data) => {

                               if(data.message){
                                    toast.current.show({
                                    severity: "warn",
                                    summary: "Upozorenje!",
                                    detail: data.message,
                                    life: 3000,
                                    });
                                    return
                                }  

                                setIdItem(null)
                                setIzabran(false)
                                setSelectedRowId(null)
                                setFormSubmitted(false)
                                setConfirmVisible(false)

                                toast.current.show({
                                    severity: "success",
                                    summary: "Uspešno!",
                                    detail: "Uspešno ste pasivizirali stavku planera!",
                                    life: 3000,
                                    });
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
           
            } else{ 
                  toast.current.show({
                    severity: "warn",
                    summary: "Upozorenje!",
                    detail: "Nije obrisana stavka planera, nije uspešno vezana za stavku!",
                    life: 3000,
                  });
            }

  }

  const exportExcel = async () => {
      if (!selectedColumns || selectedColumns.length === 0) return;
  
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('TURE');
  
      const headers = selectedColumns;
  
      // Add header row
      const headerRow = worksheet.addRow(headers);
      headerRow.font = { bold: true };
      headerRow.eachCell((cell) => {
          cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FFEFEFEF' }
          };
          cell.border = {
              top: { style: 'medium' },
              left: { style: 'medium' },
              bottom: { style: 'medium' },
              right: { style: 'medium' }
          };
      });
  
      // Add filtered data rows
      tableData.forEach((rowData) => {
          const row = worksheet.addRow(headers.map(h => rowData[h] ?? ""));
          row.eachCell((cell) => {
              cell.border = {
                  top: { style: 'thin' },
                  left: { style: 'thin' },
                  bottom: { style: 'thin' },
                  right: { style: 'thin' }
              };
          });
      });
  
      // Auto-size columns
      worksheet.columns.forEach((column, i) => {
          const lengths = [
              headers[i].length,
              ...tableData.map(row => (row[headers[i]] ?? "").toString().length)
          ];
          column.width = Math.max(...lengths) + 2;
      });
  
      // Serbian-formatted datetime
      const date = new Date();
      const options = {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          timeZone: 'Europe/Belgrade'
      };
      const serbianDateTime = date.toLocaleString('sr-RS', options)
          .replace(/\s/g, ' ')
          .replace(/,/g, '');
  
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      saveAs(blob, `Planer Tura - ${company.companyName} - ${serbianDateTime}.xlsx`);
  };

  const handleFormSubmitItems = (e) => {
             e.preventDefault(); // bitno da ne submituje bez validacije
                    setFormSubmitted(true)
                if (formRef.current && !formRef.current.checkValidity()) {
                    formRef.current.reportValidity(); // prikazuje native browser poruke
                    return;
                }
                /* Dropdown-i ne učestvuju u native validaciji, pa se obavezna
                   polja proveravaju izričito — isto kao u kalendaru. */
                if (String(formData.napomena || '').trim() === '' || !formData.tip_prevoza
                    || !formData.datum_utovara || !formData.status_plana) {
                    toast.current?.show({
                        severity: 'warn',
                        summary: 'Nedostaju obavezna polja',
                        detail: 'Tekst, tip prevoza, datum utovara i status su obavezni.',
                        life: 4000,
                    });
                    return;
                }
       saveItems()
     }

        const header = (
           <div className="export-buttons fakture-stavke-header">
               <div className="fakture-stavke-radnje">
                 <Button type="button" icon="pi pi-file-excel" severity="success" rounded onClick={exportExcel} data-pr-tooltip="XLS" />
               </div>
           </div>
       );

  return (
    <div className="p-fluid grid formUnosZap">
      <Toast ref={toast} />
      <ConfirmDialog />
      
            <ConfirmationModalPlanner
                visible={confirmVisible}
                onHide={() => {setConfirmVisible(false);setIdItem(null);setIzabran(false);setSelectedRowId(null)}}
                onConfirmRemove={can('PLANER', 'delete') ? handleFormRemoveItems : undefined}
                idItem={idItem}
            >
              <form autoComplete="off" ref={formRef}  style={{ display:'flex', flexWrap: 'wrap' }}>
                    {/* ── SLOBODAN UNOS: tekst + tri polja koja dele oba načina ── */}
                    <div className="pk-form-naslov">OBAVEZNO</div>
                    <div className="gridLicni">
                        <div className="pk-polje-puno" style={{ display: 'flex', flexDirection: 'column' }}>
                            <label htmlFor="napomena">Tekst:</label>
                            <InputTextarea id="napomena" name="napomena"
                                value={formData.napomena} onChange={handleChange}
                                required invalid={invalidControl(formData.napomena)}
                                rows={3} autoResize
                                placeholder="Kratak opis plana" />
                        </div>
                        <div className="col-12 md:col-6" style={{ display: 'flex', flexDirection: 'column' }}>
                            <label htmlFor="tip_prevoza">Tip prevoza:</label>
                            <CustomDropdown id="tip_prevoza" name="tip_prevoza"
                                value={formData.tip_prevoza} options={tipPrevozeDB || []}
                                optionLabel="label" required invalid={invalidControl(formData.tip_prevoza)}
                                onChange={handleChange} />
                        </div>
                        <div className="col-12 md:col-6" style={{ display: 'flex', flexDirection: 'column' }}>
                            <label htmlFor="datum_utovara">Datum utovara:</label>
                            <Calendar id="datum_utovara" name="datum_utovara"
                                value={formData.datum_utovara} onChange={handleChange}
                                dateFormat="dd.mm.yy" mask="99.99.9999" showButtonBar required
                                invalid={invalidControl(formData.datum_utovara)} />
                        </div>
                        <div className="col-12 md:col-6" style={{ display: 'flex', flexDirection: 'column' }}>
                            <label htmlFor="status_plana">Status:</label>
                            <CustomDropdown id="status_plana" name="status_plana"
                                value={formData.status_plana} options={statusPlanerDB || []}
                                optionLabel="label" required invalid={invalidControl(formData.status_plana)}
                                onChange={handleChange} />
                        </div>
                    </div>

                    <hr className="pk-form-linija" />

                    {/* ── DETALJNIJI UNOS: popunjava se umesto slobodnog teksta, ne uz njega ── */}
                    <div className="pk-form-naslov">
                        DETALJI
                        <span className="pk-form-napomena">nije obavezno — popunite ako imate podatke</span>
                    </div>
                    <div className="gridLicni">
                        <div className="col-12 md:col-6" style={{ display: 'flex', flexDirection: 'column' }}>
                            <label htmlFor="vreme_utovara">Vreme utovara:</label>
                            <Calendar id="vreme_utovara" name="vreme_utovara"
                                value={formData.vreme_utovara} onChange={handleChange}
                                timeOnly hourFormat="24" mask="99:99" showButtonBar />
                        </div>
                        <div className="col-12 md:col-6" style={{ display: 'flex', flexDirection: 'column' }}>
                            <label htmlFor="datum_ugovaranja">Datum ugovaranja:</label>
                            <Calendar id="datum_ugovaranja" name="datum_ugovaranja"
                                value={formData.datum_ugovaranja} onChange={handleChange}
                                mask="99.99.9999" dateFormat="dd.mm.yy" showButtonBar />
                        </div>
                        <div className="col-12 md:col-6" style={{ display: 'flex', flexDirection: 'column' }}>
                            <label htmlFor="id_klijent">Klijent (nalogodavac):</label>
                            <CustomDropdown id="id_klijent" name="id_klijent"
                                value={formData.id_klijent} options={klijentiDB || []}
                                optionLabel="label"
                                onChange={handleChange} />
                        </div>
                        <div className="col-12 md:col-6" style={{ display: 'flex', flexDirection: 'column' }}>
                            <label htmlFor="mesto_utovara">Mesto utovara:</label>
                            <InputText id="mesto_utovara" name="mesto_utovara"
                                value={formData.mesto_utovara} onChange={handleChange} />
                        </div>
                        <div className="col-12 md:col-6" style={{ display: 'flex', flexDirection: 'column' }}>
                            <label htmlFor="mesto_istovara">Mesto istovara:</label>
                            <InputText id="mesto_istovara" name="mesto_istovara"
                                value={formData.mesto_istovara} onChange={handleChange} />
                        </div>
                        <div className="col-12 md:col-6" style={{ display: 'flex', flexDirection: 'column' }}>
                            <label htmlFor="id_vozilo">Vozilo:</label>
                            <CustomDropdown id="id_vozilo" name="id_vozilo"
                                value={formData.id_vozilo} options={vozilaDB || []}
                                optionLabel="label"
                                onChange={handleChange} />
                        </div>
                        <div className="col-12 md:col-6" style={{ display: 'flex', flexDirection: 'column' }}>
                            <label htmlFor="id_prikljucno">Priključno vozilo:</label>
                            <CustomDropdown id="id_prikljucno" name="id_prikljucno"
                                value={formData.id_prikljucno} options={prikljucnaDB || []}
                                optionLabel="label" onChange={handleChange} />
                        </div>
                        <div className="col-12 md:col-6" style={{ display: 'flex', flexDirection: 'column' }}>
                            <label htmlFor="id_vozac">Vozač:</label>
                            <CustomDropdown id="id_vozac" name="id_vozac"
                                value={formData.id_vozac} options={vozaciDB || []}
                                optionLabel="label" onChange={handleChange} />
                        </div>
                        <div className="col-12 md:col-6" style={{ display: 'flex', flexDirection: 'column' }}>
                            <label htmlFor="rezim">Režim (npr. hladnjača):</label>
                            <CustomDropdown id="rezim" name="rezim"
                                value={formData.rezim} options={rezimDB || []}
                                optionLabel="label"
                                onChange={handleChange} />
                        </div>
                        <div className="col-12 md:col-6" style={{ display: 'flex', flexDirection: 'column' }}>
                            <label htmlFor="tezina">Težina (t):</label>
                            <InputNumber id="tezina" name="tezina"
                                value={formData.tezina} onValueChange={handleChange}
                                minFractionDigits={0} maxFractionDigits={2} locale="de-DE" />
                        </div>
                        <div className="col-12 md:col-6" style={{ display: 'flex', flexDirection: 'column' }}>
                            <label htmlFor="broj_paleta">Broj paleta:</label>
                            <InputNumber id="broj_paleta" name="broj_paleta"
                                value={formData.broj_paleta} onValueChange={handleChange} />
                        </div>
                        {/* Dopuna na kraju: sve ono sto se ne uklapa u polja iznad.
                            Nije obavezna — plan se snima i bez nje. */}
                        <div className="pk-polje-puno" style={{ display: 'flex', flexDirection: 'column' }}>
                            <label htmlFor="detalji">{t('plan.napomena')}:</label>
                            <InputTextarea id="detalji" name="detalji"
                                value={formData.detalji} onChange={handleChange}
                                rows={3} autoResize
                                placeholder={t('plan.napomenaPh')} />
                        </div>
                    </div>
                <div className="formUnosZap buttonUnosZap" style={{minWidth:'100%'}}>
                    <button type="submit" onClick={handleFormSubmitItems} disabled={!can('PLANER', 'edit')} style={{minWidth:"fit-content",minHeight:"fit-content", marginTop:'2%'}} className="btn btn-success">
                            {izabran ? "SAČUVAJ" : "UNOS"}
                    </button>
                </div>
            </form>
          </ConfirmationModalPlanner>

        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1em', alignItems: 'center', margin:'1%' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            {can('PLANER', 'edit') && <Button type="button" icon="pi pi-plus" severity="info" onClick={() => { resetData(); setIdItem(null); setSelectedRowId(null); setIzabran(false); setFormSubmitted(false); setConfirmVisible(true); }} data-pr-tooltip="Nova stavka" />}
            {allColumns.length > 0 && (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <MultiSelect
                  value={selectedColumns}
                  options={allColumns}
                  onChange={(e) => {
                    const sorted = originalColumnOrder.filter((key) => e.value.includes(key));
                    setSelectedColumns(sorted);
                  }}
                  optionLabel="label"
                  optionValue="value"
                  display="chip"
                  placeholder="Odaberite kolone za prikaz"
                  style={{ width: '220px' }}
                  showSelectAll={true}
                  filter
                  filterPlaceholder="Pretraži kolone"
                  maxSelectedLabels={3}
                  selectedItemsLabel="{0} kolona odabrano"
                />
                <button onClick={handleSaveConfig} style={{ marginLeft: '4px' }} className="configSaveButton">
                  <i className="pi pi-save"></i>
                </button>
              </div>
            )}
          </div>
          <div>
            <input
              type="search"
              onInput={(e) => setGlobalFilter(e.target.value)}
              placeholder="Pretraga podataka"
              className="p-inputtext p-component"
            />
          </div>
        </div>

        <div className="zaposleni_table_container tableItems" style={{maxHeight: '60vh',marginBottom:'0 !important'}}>
          <Toast ref={toast} />
              <Tooltip target=".export-buttons>button" position="bottom" />
              <DataTable
                paginator
                rows={rows}
                rowsPerPageOptions={[25, 50, 100]}
                first={first}
                header={header}
                globalFilter={globalFilter}
                onPage={(e) => { setFirst(e.first); setRows(e.rows); }}
                scrollable
                scrollHeight="50vh"
                emptyMessage={t('common.noDataTable')}
                value={tableData || []}
                resizableColumns
                className="izlazneFaktureTable stavke-tabela"
                columnResizeMode="expand"
                rowClassName={(data) => (isSelected(data) ? "selected-row" : "")}
              >
                {selectedColumns.map((colKey) => {
                const colMeta = allColumns.find(col => col.value === colKey);
                return (
                  <Column
                    key={colKey}
                    field={colKey}
                    header={colMeta?.label || colKey}
                    sortable
                    body={(rowData) => {
                      if (isButtonColumn(colKey)) {
                        return previewBodyTemplate(rowData, colKey);
                      }
                      return rowData[colKey] ?? '-';
                    }}
                  />
                );
              })}
              </DataTable>
            </div>
    </div>
  );
};

export default PregledPlanaTure;
